import { UpcomingTypes } from './types';

const { TOGGLE_TASK } = UpcomingTypes;

interface UpcomingState {
  toggleTask: any;
}

export const initialState: UpcomingState = {
  toggleTask: null,
};

// eslint-disable-next-line default-param-last
const studyReducer = (state = initialState, action: any): UpcomingState => {
  switch (action.type) {
    case TOGGLE_TASK: {
      return {
        ...state,
        toggleTask: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default studyReducer;
